import DurationInputField from './DurationInputField';

export default DurationInputField;
